<template>

    <section id="blog" class="blog-container vertical-scrolling">
    <div class="blog-title-container">

    <h1>{{$lang.blog.blog_title}}</h1>
    <p>{{$lang.blog.blog_desc}}</p>
    
    </div>
    <blog-feed :feeds="feeds"></blog-feed>
    </section>
</template>

<script>
import BlogFeed from "@/components/blog/BlogFeed.vue";
// import BlogInfo from "../blogs/en/blogFeeds/feeds.json"
// import FirebaseService from '@/connections/firebase.service';
export default {
  name: "BlogSection",
  props: [],
  components: {
   BlogFeed
  },
  data() 
    {
    return {
      style: "",
      feeds:[]
    };
  },
  metaInfo() {
    const me = this;
    return{
      title: me.$lang.blog.blog_title,//me.$lang.about.taption,

      meta: [
        { vmid: 'name', content: me.$lang.blog.blog_title, itemprop: 'name' },
        { vmid: 'description', content: me.$lang.blog.blog_desc, itemprop: 'description' },
        { vmid: 'article_desc', content: me.$lang.blog.blog_desc, name: 'description' },
        { vmid: 'og_title', content: me.$lang.blog.blog_title, property: 'og:title' },
        { vmid: 'og_desc', content: me.$lang.blog.blog_desc, property: 'og:description' },
        { vmid:'twitter_title', content: me.$lang.blog.blog_title, name: 'twitter:title' },
        { vmid:'twitter_desc',content: me.$lang.blog.blog_desc, name: 'twitter:description' },
      ]
    }
  },
  methods: {
    // async navToBlog(blog){
    //   const me = this;
    //   me.$router.push({name:"blogpost", params: { language: blog.language, post: blog.id}});
    // },
    onClick() {
      const me = this;
      me.$router.push({ name: me.navigate || "taption" });
    },
    async getBlogFeeds(){
      const me = this;
      let language = me.$route.params.language || (window.localStorage.getItem('PrefferedLanguage') || 'en').toLowerCase();
      language = language.split('-')[0];
      const tempFeeds = require(`../blogs/${language}/blogFeeds/feeds.json`);
    

      tempFeeds.sort(function(a,b){
        return b.date-a.date;
      });
      return tempFeeds;
    },
  },
async created(){
  const me = this;
    me.feeds = await me.getBlogFeeds();
}
};
</script>

<style>

.blog-container{
  padding-top:130px;
}
.blog-title-container{
  width:700px;
  margin: 0 auto;
}
.blog-title-container p{
  padding: 30px 0px;
}
.blog-container h1{
  font-size: 50px;
  line-height: 55px;
}
.blog-container h1.subTitle{
  font-size: 25px;
  line-height: 30px;
  font-weight: 600;
}

.blog-container h2{
  color: #000;
    font-size: 25px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 0!important;
    text-transform: none;
}
.blog-container h2.subtitle{
  color: #000;
    font-size: 25px;
    font-weight: 400;
    box-shadow: inset 3px 0 0 0 #292929;
    padding-left: 20px;
    margin-left: -20px;
    margin-top: 2em!important;
    line-height: 40px;
    letter-spacing: 0!important;
    text-transform: none;
}
.blog-container li{
  font-size: 20px;
  color:#292929;
}
.blog-container li::marker{
  font-size: 16px;
  color:#292929;
}
.blog-container p{
  font-size: 20px;
  color:#292929;
}

.v-btn.return{
  border:1px solid #797676;
  border-radius: 25px;
  position: absolute;
  left:200px;
}
.v-btn.return.bottom{

bottom:45px; 
top:auto;
}

@media only screen and (max-device-width: 600px) {
.blog-title-container {
    width: 100%;
    margin: 0 auto;
}
.blog-container h1{
  font-size: 35px;
  line-height: 35px;
}
.v-btn.return{
  left:30px;
  top:100px;
}
.v-btn.return.bottom{

  bottom:65px; 
  top:auto;
}

}
</style>
